import React from 'react'
import PropTypes from 'prop-types'

import Error from '../Error/Error'

const OOGlobalsContext = React.createContext({})

export const OOGlobalsProvider = ({
  devError,
  enabledFeatureFlags,
  outpostIdentifier,
  gatewayBaseUri,
  toastwebBaseUri,
  restaurantGuid,
  routerBasename,
  shortUrl,
  spaVersion,
  spaPreviousVersion,
  managementGroupGuid,
  mode,
  mapboxAccessToken,
  toastTakeoutCTAEnabled,
  children
}) => {
  const context = {
    devError,
    enabledFeatureFlags,
    outpostIdentifier,
    gatewayBaseUri,
    toastwebBaseUri,
    restaurantGuid,
    routerBasename,
    shortUrl,
    spaVersion,
    managementGroupGuid,
    mode,
    mapboxAccessToken,
    spaPreviousVersion,
    toastTakeoutCTAEnabled
  }

  return (
    <OOGlobalsContext.Provider value={context}>
      {children}
    </OOGlobalsContext.Provider>
  )
}

OOGlobalsProvider.propTypes = {
  children: PropTypes.element.isRequired,

  // Should only possibly get set in local dev mode.
  devError: PropTypes.object,
  enabledFeatureFlags: PropTypes.array,
  outpostIdentifier: PropTypes.string,
  gatewayBaseUri: PropTypes.string,
  toastwebBaseUri: PropTypes.string,
  restaurantGuid: PropTypes.string,
  routerBasename: PropTypes.string.isRequired,
  shortUrl: PropTypes.string,
  spaVersion: PropTypes.string.isRequired,
  spaPreviousVersion: PropTypes.string.isRequired,
  mode: PropTypes.string,
  mapboxAccessToken: PropTypes.string,
  managementGroupGuid: PropTypes.string,
  toastTakeoutCTAEnabled: PropTypes.bool
}

export const OOGlobalsConsumer = ({ children }) => (
  <OOGlobalsContext.Consumer>
    {context =>
      <React.Fragment>
        {context.devError && <Error error={context.devError} />}
        {children(context)}
      </React.Fragment>
    }
  </OOGlobalsContext.Consumer>
)

OOGlobalsConsumer.propTypes = {
  children: PropTypes.func.isRequired
}

export const useOOGlobals = () => React.useContext(OOGlobalsContext)

export const MockOOGlobalsProvider = ({
  mocks: {
    enabledFeatureFlags,
    outpostIdentifier,
    gatewayBaseUri,
    toastwebBaseUri,
    restaurantGuid,
    routerBasename,
    shortUrl,
    spaVersion,
    spaPreviousVersion,
    managementGroupGuid,
    mode,
    mapboxAccessToken,
    toastTakeoutCTAEnabled
  },
  children
}) => {
  const context = {
    enabledFeatureFlags,
    outpostIdentifier,
    gatewayBaseUri,
    toastwebBaseUri,
    restaurantGuid,
    routerBasename,
    shortUrl,
    spaVersion,
    spaPreviousVersion,
    managementGroupGuid,
    mode,
    mapboxAccessToken,
    toastTakeoutCTAEnabled
  }

  return (
    <OOGlobalsContext.Provider value={context}>
      {children}
    </OOGlobalsContext.Provider>
  )
}

MockOOGlobalsProvider.propTypes = {
  children: PropTypes.element.isRequired,
  mocks: PropTypes.shape({
    enabledFeatureFlags: PropTypes.array,
    outpostIdentifier: PropTypes.string,
    gatewayBaseUri: PropTypes.string,
    toastwebBaseUri: PropTypes.string,
    restaurantGuid: PropTypes.string,
    routerBasename: PropTypes.string,
    shortUrl: PropTypes.string,
    spaVersion: PropTypes.string,
    spaPreviousVersion: PropTypes.string,
    mode: PropTypes.string,
    managementGroupGuid: PropTypes.string,
    mapboxAccessToken: PropTypes.string,
    toastTakeoutCTAEnabled: PropTypes.bool
  }).isRequired
}
